// src/components/AccessDenied.tsx
import React from "react";
import { MdLock } from "react-icons/md";
import { Link } from "react-router-dom";

export default function AccessDenied(): React.ReactElement {
  return (
    <div className="p-6 flex items-center justify-center">
      <div className="w-full max-w-xl rounded-2xl border border-surface bg-surface p-6 shadow-sm">
        <div className="mb-4 flex items-center gap-3">
          <div className="icon-accent text-3xl">
            <MdLock />
          </div>
          <h1 className="text-xl font-semibold">Sin permisos suficientes</h1>
        </div>

        <p className="text-on-surface/80">
          Tu cuenta no tiene acceso a esta sección del panel. Si crees que se
          trata de un error, ponte en contacto con un administrador.
        </p>

        <div className="mt-5 flex gap-2">
          <Link to="/" className="btn btn-primary">
            Ir al inicio
          </Link>
          <a
            href="mailto:soporte@example.com?subject=Solicitud%20de%20acceso"
            className="btn btn-outline"
          >
            Contactar soporte
          </a>
        </div>
      </div>
    </div>
  );
}
